import { FormData } from "../../hooks/rtmTemplate/index.type";
import { QuestionWithErrors } from "./MultipleCategorySection";
import React, { FC, useState } from "react";
import toast from "react-hot-toast";
import styles from "../../styles/Template.module.css";
import { Button } from "../../components/Modal";
import SelectInputBox from "../../components/Modal/SelectInputBox";

interface QuestionSectionProps {
  formData?: FormData;
  setFormData?: React.Dispatch<React.SetStateAction<FormData>>;
  currentQuestion: QuestionWithErrors;
  setCurrentQuestion?: React.Dispatch<React.SetStateAction<QuestionWithErrors>>;
  setNext?: React.Dispatch<React.SetStateAction<boolean>>;
  validateQuestion: () => boolean;
  isEditing?: boolean;
handleToggleEditState: (state: boolean) => void;
}

const QuestionSection: FC<QuestionSectionProps> = ({
  formData,
  setFormData,
  currentQuestion,
  setCurrentQuestion,
  validateQuestion,
  isEditing,
  handleToggleEditState,
}) => {
  const [selectedQuestionId, setSelectedQuestionId] = useState("");
  const [selectedOptionKey, setSelectedOptionKey] = useState("");

  React.useEffect(() => {
    if (currentQuestion.questionDependable === "yes") {
      setSelectedQuestionId(currentQuestion.dependableQuestionId || "");
      setSelectedOptionKey(currentQuestion.dependableQuestionOption || "");
    }
    console.log(formData);
  }, [currentQuestion]);

  const handleDependableChange = (isDependable: "yes" | "no") => {
    if (!setCurrentQuestion) return;

    const updatedQuestion = {
      ...currentQuestion,
      questionDependable: isDependable,
    };

    if (!isDependable) {
      updatedQuestion.dependableQuestionId = "";
      updatedQuestion.dependableQuestionOption = "";
      updatedQuestion.dependableQuestionType = "";
      setSelectedQuestionId("");
      setSelectedOptionKey("");
    }

    setCurrentQuestion((prev) => ({
      ...updatedQuestion,
      errors: {
        ...prev.errors,
        questionDependable: "",
      },
    }));
  };

  const handleDependentQuestionSelect = (questionId: string) => {
    setSelectedQuestionId(questionId);

    const selected = formData?.questions.find(
      (q) => q.questionId === questionId
    );
    if (selected && setCurrentQuestion) {
      setCurrentQuestion((prev) => ({
        ...prev,
        dependableQuestionId: selected.questionId,
        dependableQuestionType: selected.answerType,
        hasQuestionDependOnThis:
          selected.questionDependable === "yes" ? "yes" : "no",
        errors: {
          ...prev.errors,
          dependableQuestionId: "",
          dependableQuestionOption: "",
        },
      }));
    }
  };

  const handleDependentOptionSelect = (optionKey: string) => {
    setSelectedOptionKey(optionKey);
    if (setCurrentQuestion) {
      setCurrentQuestion((prev) => ({
        ...prev,
        dependableQuestionOption: optionKey,
        errors: { ...prev.errors, dependableQuestionType: "" },
      }));
    }
  };

  const selectedQuestion = formData?.questions.find(
    (q) => q.questionId === selectedQuestionId
  );

  // const handleAddMore = () => {
  //   if (!formData || !setFormData || !setCurrentQuestion) return;

  //   const isValid = validateQuestion();

  //   if (!isValid) {
  //     toast.error("Validation failed. Question not added.");
  //     return;
  //   }

  //   const questionWithId = {
  //     ...currentQuestion,
  //     questionId: currentQuestion.questionId || `${Date.now()}`,
  //   };

  //   let updatedQuestions;
  //   const existingIndex = formData.questions.findIndex(
  //     (q) => q.questionId === questionWithId.questionId
  //   );

  //   if (existingIndex !== -1) {
  //     // Update existing question, preserve its sequence
  //     const existingQuestion = formData.questions[existingIndex];
  //     updatedQuestions = [...formData.questions];
  //     updatedQuestions[existingIndex] = {
  //       ...questionWithId,
  //       sequence: existingQuestion.sequence,
  //     };
  //   } else {
  //     // Add new question
  //     const newQuestion = {
  //       ...questionWithId,
  //       sequence: formData.questions.length + 1,
  //     };
  //     updatedQuestions = [...formData.questions, newQuestion];

  //     // Reassign sequence for new question only (or leave as above)
  //   }

  //   const updatedFormData = {
  //     ...formData,
  //     questions: updatedQuestions,
  //   };

  // setFormData(updatedFormData);
  // //  handleToggleEditState()

  //   setCurrentQuestion({
  //     text: "",
  //     questionId: "",
  //     categoryId: "",
  //     sequence: 0,
  //     answerType: "",
  //     option: [{ key: "", name: "", textboxRequired: "no" }],
  //     scale: {
  //       min: { key: "", name: "", textboxRequired: "no" },
  //       max: { key: "", name: "", textboxRequired: "no" },
  //     },
  //     hasQuestionDependOnThis: "no",
  //     questionDependable: "no",
  //     dependableQuestionId: "",
  //     dependableQuestionOption: "",
  //     dependableQuestionType: "",
  //     errors: {},
  //   });

  //   setSelectedQuestionId("");
  //   setSelectedOptionKey("");
  // };

 const handleAddMore = () => {
  if (!formData || !setFormData || !setCurrentQuestion) return;

  const isValid = validateQuestion();
  if (!isValid) {
    toast.error("Validation failed. Question not added.");
    return;
  }

  const questionWithId = {
    ...currentQuestion,
    questionId: currentQuestion.questionId || `${Date.now()}`,
  };

  let updatedQuestions = [...formData.questions];
  const existingIndex = updatedQuestions.findIndex(
    (q) => q.questionId === questionWithId.questionId
  );

  let newQuestion;

  if (existingIndex !== -1) {
  
    newQuestion = {
      ...questionWithId,
      sequence: updatedQuestions[existingIndex].sequence,
    };

    updatedQuestions[existingIndex] = newQuestion;
  } else {
   
    let newSequence = 1;

    if (
      questionWithId.questionDependable === "yes" &&
      questionWithId.dependableQuestionId
    ) {
      const parentQuestion = updatedQuestions.find(
        (q) => q.questionId === questionWithId.dependableQuestionId
      );
      if (parentQuestion) {
        newSequence = parentQuestion.sequence + 1;
      }
    } else {
      const maxSequence = updatedQuestions.reduce(
        (max, q) => Math.max(max, q.sequence),
        0
      );
      newSequence = maxSequence + 1;
    }

    newQuestion = {
      ...questionWithId,
      sequence: newSequence,
    };

    updatedQuestions.push(newQuestion);
  }


  setFormData({
    ...formData,
    questions: updatedQuestions,
  });

  setCurrentQuestion({
    text: "",
    questionId: "",
    categoryId: "",
    sequence: 0,
    answerType: "",
    option: [{ key: "", name: "", textboxRequired: "no" }],
    scale: {
      min: { key: "", name: "", textboxRequired: "no" },
      max: { key: "", name: "", textboxRequired: "no" },
    },
    hasQuestionDependOnThis: "no",
    questionDependable: "no",
    dependableQuestionId: "",
    dependableQuestionOption: "",
    dependableQuestionType: "",
    errors: {},
  });

if(!selectedQuestionId) {
  handleToggleEditState(false);
}

  setSelectedQuestionId("");
  setSelectedOptionKey("");
};

  return (
    <div className={styles.question_section}>
      <div className={styles.question_flex_wrapper}>
        {formData?.questions?.some((q) => q.answerType === "single_option") && (
          <div className={styles.question_wrapper}>
            <div className={styles.sub_section_4}>
              <div className={styles.dependent_text}>
                <span>Is this question dependent on another?</span>
                <span className={styles.dependent_error_text}>
                  {currentQuestion.errors?.questionDependable}
                </span>
              </div>

              <div className={styles.category_btn}>
                <Button
                  span={false}
                  label="Yes"
                  // customClass={styles.button}
                  customClass={
                    currentQuestion.questionDependable === "yes"
                      ? styles.button_active
                      : styles.button
                  }
                  onClick={() => handleDependableChange("yes")}
                />
                <Button
                  span={false}
                  label="No"
                  // customClass={styles.button}
                  onClick={() => handleDependableChange("no")}
                  customClass={
                    currentQuestion.questionDependable === "no"
                      ? styles.button_active
                      : styles.button
                  }
                />
              </div>
            </div>

            {currentQuestion.questionDependable === "yes" && (
              <div
                className={`${styles.question_selectbox_container} ${styles.show}`}
              >
                {/* First Dropdown - Questions with answerType "single_option" only */}
                <SelectInputBox
                  className={styles.question_selectbox}
                  value={selectedQuestionId}
                  onChange={(e) =>
                    handleDependentQuestionSelect(e.target.value)
                  }
                  errorClass={styles.error}
                  errorMessage={
                    currentQuestion.errors?.dependableQuestionOption
                  }
                  containerClass={styles.question_section_inputField}
                >
                  <option value="">Question</option>
                  {formData?.questions
                    ?.filter((q) => q.answerType === "single_option")
                    .map((q) => (
                      <option key={q.questionId} value={q.questionId}>
                        {q.text}
                      </option>
                    ))}
                </SelectInputBox>

                {/* Second Dropdown - Options */}
                <SelectInputBox
                  className={styles.question_selectbox}
                  value={selectedOptionKey}
                  onChange={(e) => handleDependentOptionSelect(e.target.value)}
                  containerClass={styles.question_section_inputField}
                  errorClass={styles.error}
                  errorMessage={currentQuestion.errors?.dependableQuestionType}
                >
                  <option value="">Answer Option</option>
                  {selectedQuestion?.option.length ? (
                    selectedQuestion.option.map((opt) => (
                      <option key={opt.key} value={opt.key}>
                        {opt.name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No options available</option>
                  )}
                </SelectInputBox>
              </div>
            )}
          </div>
        )}
      </div>

      <Button
        span={false}
        label={isEditing ? "Update" : "Add More"}
        icon={isEditing ? "icon-edit-3" : "icon-add"}
        customClass={styles.add_btn}
        iconStyle={{ width: "2rem", height: "1.5rem" }}
        onClick={handleAddMore}
      />
    </div>
  );
};

export default QuestionSection;
